var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"pup",on:{"click":_vm.close}},[_c('div',{staticClass:"pup_div",on:{"click":function($event){$event.stopPropagation();}}},[_c(_vm.name,{tag:"component",attrs:{"type":_vm.type},on:{"close":_vm.close,"goodList":_vm.goodList}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }